import { fetchAPI } from '../utils/api';

const handleDataResponse = (res: Response) => {
  if (res.status !== 200) {
    throw new Error(res.statusText);
  }
  return res.json();
};

const handleEmptyResponse = (res: Response) => {
  if (res.status !== 200) {
    throw new Error(res.statusText);
  }
  return res.ok;
};

const handleDataArrayResponse = (res: Response) => {
  if (res.status !== 200) {
    return [];
  }
  return res.json();
};

export const getFreeTrialRequests = (
  page = 1,
  perPage = 10
): Promise<{
  items: FreeTrialRequestResponse[];
  pagination: { total: number };
}> => {
  return fetchAPI(`/back-office/free-trials`, {
    method: 'GET',
    payload: {
      page,
      per_page: perPage,
    },
  }).then(handleDataResponse);
};

export const getFreeTrialRequestById = (
  id: number
): Promise<FreeTrialRequestResponse> => {
  return fetchAPI(`/back-office/free-trials/${id}`, {
    method: 'GET',
  }).then(handleDataResponse);
};

export const createFreeTrialRequest = (
  payload: FreeTrialRequest
): Promise<boolean> => {
  return fetchAPI(`/back-office/free-trials`, {
    method: 'POST',
    payload,
  }).then(handleEmptyResponse);
};

export const updateFreeTrialRequest = (
  id: number,
  version_id: number,
  payload: FreeTrialRequest
): Promise<boolean> => {
  return fetchAPI(`/back-office/free-trials/${id}/versions/${version_id}`, {
    method: 'PATCH',
    payload,
  }).then(handleEmptyResponse);
};

export const rejectFreeTrialRequest = (
  id: number,
  version_id: number,
  payload: { reject_remarks: string }
): Promise<boolean> => {
  return fetchAPI(
    `/back-office/free-trials/${id}/versions/${version_id}/reject`,
    {
      method: 'PATCH',
      payload,
    }
  ).then(handleEmptyResponse);
};

export const cloneFreeTrialRequest = (
  id: number,
  version_id: number
): Promise<boolean> => {
  return fetchAPI(
    `/back-office/free-trials/${id}/versions/${version_id}/clone`,
    {
      method: 'POST',
    }
  ).then(handleEmptyResponse);
};

export const approveFreeTrialRequest = (
  id: number,
  version_id: number
): Promise<boolean> => {
  return fetchAPI(
    `/back-office/free-trials/${id}/versions/${version_id}/approve`,
    {
      method: 'PATCH',
    }
  ).then(handleEmptyResponse);
};

export const activateFreeTrialRequest = (
  id: number,
  version_id: number
): Promise<boolean> => {
  return fetchAPI(
    `/back-office/free-trials/${id}/versions/${version_id}/activate`,
    {
      method: 'PATCH',
    }
  ).then(handleEmptyResponse);
};

export const getUsers = (
  query = ''
): Promise<{
  items: UserInfo[];
}> => {
  return fetchAPI(`/back-office/subscription-requests/users?q=${query}`, {
    method: 'GET',
  }).then(handleDataArrayResponse);
};

export const getDataItems = (
  query = ''
): Promise<{
  items: DataItem[];
}> => {
  return fetchAPI(`/back-office/subscription-requests/data-items?q=${query}`, {
    method: 'GET',
  }).then(handleDataArrayResponse);
};

export const getShopItemCategories = (
  query = ''
): Promise<{
  items: ShopItemCategory[];
}> => {
  return fetchAPI(
    `/back-office/subscription-requests/shop-item-categories?q=${query}`,
    {
      method: 'GET',
    }
  ).then(handleDataArrayResponse);
};

export const checkUserFlowType = () =>
  fetchAPI('/users/check_user_flow_type', {
    method: 'GET',
    version: '1.2',
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./app/api/free_trials.ts